import NavHeader from "../shared/Nav-Header";
import { useState, useEffect, useMemo } from "react";
import styles from './channels.module.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Notification from '../shared/Notification';
import SocialMessageBox from '../shared/SocialMessageBox';
import defaultProfile2 from '../images/default-profile2.jpg';
import { CopyLinkIcon, LeaveGroupIcon, ReportIcon, DeleteIcon } from '../shared/icons/Icons';
import defaultChannel1 from '../images/channels/channel-1.png'
import { useAuth } from '../context/AuthContext';
import { io } from 'socket.io-client';


const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-a1b2.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});

const Channels = () => {
    const { userId } = useAuth();
    const [showChannelCreation, setShowChannelCreation] = useState(false);
    const [notification, setNotification] = useState('');
    const [channelName, setChannelName] = useState('');
    const [selectedNetworks, setSelectedNetworks] = useState([]);
    const [myChannels, setMyChannels] = useState([]);
    // const [myActiveChannels, setMyActiveChannels] = useState([]);
    // const [leftChannels, setLeftChannels] = useState([]);
    const [activeChannelChat, setActiveChannelChat] = useState(null);
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    // const [name, setName] = useState('');
    // const [profilePicture, setProfilePicture] = useState('');
    // const [reload, setReload] = useState(false);
    const [newChannelCreated, setNewChannelCreated] = useState(false);
    const [showOptions, setShowOptions] = useState(null);
    // const [leaveChannelPopup, setLeaveChannelPopup] = useState(false);
    const [reportChannelPopup, setReportChannelPopup] = useState(false);
    const [reportChannelId, setReportChannelId] = useState(null);
    const navigate = useNavigate();
    const [reportMessage, setReportMessage] = useState('');
    const [allChannels, setAllChannels] = useState([]);
    const newChannels = useMemo(() => {
        // console.log("newChannels:1",allChannels.filter(channel => !myChannels.some(myChannel => myChannel._id === channel._id)))
        return allChannels.filter(channel => !myChannels.some(myChannel => myChannel._id === channel._id));
    }, [allChannels, myChannels]);
    const [joinedChannels, setJoinedChannels] = useState([]); // Track joined channels
    const joined = (channelId) => joinedChannels.includes(channelId);
    const token = useMemo(() => localStorage.getItem('token'), []);
    const socialType = 'channel';

    const fetchData = async () => {
        try {
            if (!token) {
                localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                navigate('/login');
                return;
            }
            const response = await axios.get('/api/pn/my-networks', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // console.log("my-networks", response.data);
            const projectNetworkList = response.data;
            setProjectNetworkList(projectNetworkList);
            // console.log('Profile Picture:', profilePicture);
            // console.log('Project Network List:', projectNetworkList);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error fetching project networks data';
            // console.error(errorMessage);
            setNotification('Error fetching project networks data. Please try again.');
        }
    };


    useEffect(() => {
        if (!token) {
            localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
            navigate('/login');
            return;
        }
        
        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
            }
    }, [navigate]);


    useEffect(() => {
        const fetchChannels = async ()=> {
            try {
                const response = await axios.get('/api/channel/my-channels', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMyChannels(response.data.channels);
                // console.log('response.data.', response.data);
                // console.log('response.data.applicant:', response.data.applicant);
                // console.log('response.data.channels:', response.data.channels);
                
                // console.log('response.data.channels:', response.data.channels.map(g => g.membership));
                // setMyActiveChannels(response.data.channels.filter(channel =>channel.membership === 'member'));
            } catch (error) {
                console.error('Error fetching user channels:', error);
            }
        }
        fetchChannels();

        const newChannels = async ()=> {
            try {
                const response = await axios.get('/api/channel/all-channels', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setAllChannels(response.data.channels);
                // setJoinedChannels(response.data.channels); // Set joined channels
                // console.log('response.data.', response.data);
            } catch (error) {
                console.error('Error fetching all channels:', error);
            }
        }
        newChannels();
        

    }, []);
    useEffect(() => {
        const handleChannelSort = ({ socialId, createdAt }) => {
            setMyChannels(prev => {
                // Check if channel exists
                const channelExists = prev.some(g => g._id === socialId);
                if (!channelExists) return prev;
                // Update and sort
                return [...prev]
                    .map(g =>
                        g._id === socialId
                            ? { ...g, lastMessageCreatedAt: createdAt }
                            : g
                    )
                    .sort((a, b) => {
                        const dateA = new Date(a.lastMessageCreatedAt || 0);
                        const dateB = new Date(b.lastMessageCreatedAt || 0);
                        return dateB - dateA; // Descending order (latest first)
                    });
            });
        };

        socket.on('channelLastMessageUpdate', handleChannelSort);
        return () => socket.off('channelLastMessageUpdate', handleChannelSort);
    }, []);
    // useEffect(() => {
    //     setLeftChannels(myChannels.filter(channel =>channel.membership === 'left'));
    //     console.log('Active Channels:', myActiveChannels);
    //     console.log('Left Channels:', leftChannels);
    // }, [myChannels]);

    const handleShowChannelCreation = () => {
        fetchData();
        if(showChannelCreation) {
            setShowChannelCreation(false);
        } else {
            setShowChannelCreation(true);
        }
    };

    const handleCreateChannel = async () => {

        try {
            const response = await axios.post('/api/channel/create-channel', {
                channelName,
                userIds: selectedNetworks
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setChannelName('');
                setSelectedNetworks([]);
                setShowChannelCreation(false);
                setTimeout(() => setNewChannelCreated(true), 0);
                setNotification(response.data.message || 'Channel created successfully!');
            }
        } catch (error) {
            console.error('Error creating channel:', error.message);
            const errorMessage = error.response?.data?.message || 'Error creating channel. Please try again.';
            setNotification(errorMessage);
        }
    };

     const handleSelectNetwork = async (event, networkId) => {
        event.stopPropagation();
        setSelectedNetworks((prevSelected) => {
            if (prevSelected.includes(networkId)) {
                return prevSelected.filter(id => id !== networkId);
            } else {
                return [...prevSelected, networkId];
            }
        });
    };

    const handleJoinChannel = async (e, channelId) => {
        e.preventDefault();
        e.stopPropagation();
            try {
                const response = await axios.post('/api/channel/join-channel-home', {
                    channelId,
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (response.data.success) {
                    setNotification(response.data.message || 'Joined Channel successfully!');
                    setJoinedChannels(prevJoinedChannels => [...prevJoinedChannels, channelId]); // Update applied jobs
                }
            } catch (error) {
                // console.error('Error joining channel:', error);
                const errorMessage = error.response?.data?.message || 'Error joining channel. Please try again.';
                setNotification(errorMessage);
            }
    };

    const handleLeaveChannel = async (e, channelId) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const response = await axios.post('/api/channel/leave-channel', {
                channelId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Channel Left successfully!');
                setNotification( 'Channel Left successfully!');
            }
        } catch (error) {
            // console.error('Error leaving channel:', error);
            const errorMessage = error.response?.data?.message || 'Error leaving channel. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleDeleteChannel = async (channelId) => {
        try {
            const response = await axios.post('/api/channel/delete-channel', {
                channelId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Channel Deleted successfully!');
            }
        } catch (error) {
            console.error('Error leaving channel:', error.message);
            const errorMessage = error.response?.data?.message || 'Error deleting channel. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleCopyInviteLink = async (e, channelId) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const response = await axios.post('/api/channel/invite-link', 
                { channelId },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                const inviteLink = response.data.inviteLink;
                
                await navigator.clipboard.writeText(inviteLink);
                
                const expiresAt = new Date(response.data.expiresAt);
                const now = new Date();
                const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));
                
                setNotification(`Invite link copied to clipboard! Valid for ${daysLeft} days.`);
            }
        } catch (err) {
            // console.error('Error generating invite link:', err.message);
            setNotification(err.response?.data?.message || 'Failed to generate invite link. Please try again.');
        }
    };

    const handleReportChannel = async (e, channelId) => {
        e.preventDefault();
        e.stopPropagation();            
        try{
            await axios.post('/api/channel/report-channel', {
                channelId: channelId,
                reportMessage: reportMessage
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setReportChannelPopup(false);
            setNotification('Channel reported. Our team will review it shortly.');
        }
        catch (error) {
            // console.error('Error reporting channel:', error.message);
            const errorMessage = error.response?.data?.message || 'Error reporting channel. Please try again.';
            setNotification(errorMessage);
        }
        
    }
    const handleReportChannelPopup = (channelId) => {
        setReportChannelPopup(true);
        setReportChannelId(channelId);
    };
    const cancelReportChannel = () => {
        setReportChannelPopup(false);
    };

    const handleChannelClick = async (event, channel) => {
        event.stopPropagation();
        event.preventDefault();
        navigate(`/channel/${channel._id}`
            ,{ state: { userId: userId } });
    };
    const handleChannelChatClick = async (event, channel) => {
        event.stopPropagation();
        setActiveChannelChat(channel);
    };

     const handleCloseChat = () => {
        setActiveChannelChat(null);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };
    const handleBack = () => {
        navigate(-1);
    }
    const handleChannelOptions = (event, index) => {
        event.stopPropagation();
        if (showOptions === index) {
            setShowOptions(null);
        } else {
            setShowOptions(index);
        }
    };

    const handleClickOutside = (event) => {
        if (!event.target.closest(`.${styles.threeDotsButton}`) && !event.target.closest(`.${styles.messageOptionsMenu}`)) {
            setShowOptions(null);
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleProfileClick = async (event, networkId) => {
        event.stopPropagation();
        const profileStatus = 'friends';
        // console.log("profileStatus:hp", profileStatus);
        navigate(`/profile/${networkId}`, { state: profileStatus });  
    };
    return (
        <div>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <br/><br/>
            <br/><br/>
             <br/>
            {/* <h1>Channel</h1> */}

             {/* {(!myActiveChannels || myActiveChannels.length !== 0) && (
                <>
                <div className={`${styles.myChannelsSection} ${styles.pnChannel}`}>
                    {(!myChannels || myChannels.length !== 0) && (
                        <>
                        <h3>👥Active Channels👥 ({myActiveChannels.length})</h3>
                        <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                        <ul>
                            <div className={styles.channelBox}>
                                <div className={styles.channelContainer}>
                                    {myActiveChannels?.map((channel, index) => (
                                        <div  className={styles.channelItem}>
                                            <li key={channel._id} onClick={(e) => handleChannelClick(e, channel)}>
                                                <div className={styles.channelContent}></div>
                                                <img title={channel.name} src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultChannel1}alt="pfp" className={styles.networkProfilePicture} />
                                                    <span className={styles.channelName}>🌟 {channel.name} 🌟</span>
                                                    <span className={styles.channelMembers}>{channel.participantCount} members</span>
                                                    <button 
                                                        className={styles.threeDotsButton} 
                                                        onClick={(e) => {handleChannelOptions(e, showOptions === index ? null : index)}} title="options"
                                                    >
                                                        ⋮
                                                    </button>
                                                    <div className={styles.channelActivity}>
                                                        <span className={styles.activityIndicator}>💚 Active now!</span>
                                                        <span className={styles.activityIndicator} onClick={(e) => handleChannelChatClick(e, channel)}>💚 Chat📃</span>
                                                    </div>
                                            </li>
                                            {showOptions === index && (
                                                <div className={styles.messageOptionsMenu}>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleCopyInviteLink(e, channel._id);setShowOptions(null)}}>
                                                        <CopyLinkIcon/>
                                                        Copy Invite Link
                                                    </button>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleLeaveChannel(e, channel._id);setShowOptions(null)}}>
                                                        <LeaveGroupIcon/>
                                                        Leave Channel
                                                    </button>
                                                    <button 
                                                    onClick={(e) => {handleReportChannelPopup(channel._id);setShowOptions(null)}}>
                                                        <ReportIcon/>
                                                        Report Channel
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </ul>
                        </>
                        )}

                    {(!leftChannels || leftChannels.length !== 0) && (
                    <>
                    <h3>Left Channels👥 ({leftChannels.length})</h3>
                    <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                    <ul>
                        <div className={styles.channelBox}>
                            <div className={styles.channelContainer}>
                                {leftChannels?.map((channel, index) => (
                                    <div  className={styles.channelItem}>
                                        <li key={channel._id} onClick={(e) => handleChannelClick(e, channel)}>
                                            <div className={styles.channelContent}></div>
                                            <img title={channel.name} src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultChannel1}alt="pfp" className={styles.networkProfilePicture} />
                                                <span className={styles.channelName}>🌟 {channel.name} 🌟</span>
                                                <span className={styles.channelMembers}>{channel.participantCount} members</span>
                                                <button 
                                                    className={styles.threeDotsButton} 
                                                    onClick={(e) => {handleChannelOptions(e, showOptions === index ? null : index)}} title="options"
                                                >
                                                    ⋮
                                                </button>
                                                <div className={styles.channelActivity}>
                                                    <span className={styles.activityIndicator}>💚 Active now!</span>
                                                    <span className={styles.activityIndicator} onClick={(e) => handleChannelChatClick(e, channel)}>💚 Chat📃</span>
                                                </div>
                                        </li>
                                        {showOptions === index && (
                                            <div className={styles.messageOptionsMenu}>
                                                <button 
                                                onClick={(e) => 
                                                {handleCopyInviteLink(e, channel._id);setShowOptions(null)}}>
                                                    <CopyLinkIcon/>
                                                    Copy Invite Link
                                                </button>
                                                <button 
                                                onClick={(e) => 
                                                {handleLeaveChannel(e, channel._id);setShowOptions(null)}}>
                                                    <LeaveGroupIcon/>
                                                    Leave Channel
                                                </button>
                                                <button 
                                                onClick={(e) => {handleReportChannelPopup(channel._id);setShowOptions(null)}}>
                                                    <ReportIcon/>
                                                    Report Channel
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </ul>
                    </>
                )}
                </div>
                </>
            )}
             */}
            {(!myChannels || myChannels.length !== 0) && (
                <div className={`${styles.myChannelsSection} ${styles.pnChannel}`}>
                        <h3>👥Active Channels👥 ({myChannels.length})</h3>
                        <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                        <ul>
                            <div className={styles.channelBox}>
                                <div className={styles.channelContainer}>
                                    {myChannels?.map((channel, index) => (
                                        <div  className={styles.channelItem}>
                                            <li key={channel._id} onClick={(e) => handleChannelClick(e, channel)}>
                                                <div className={styles.channelContent}></div>
                                                <img title={channel.name} src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultChannel1}alt="pfp" className={styles.networkProfilePicture} />
                                                    <span className={styles.channelName}>🌟 {channel.name} 🌟</span>
                                                    <span className={styles.channelMembers}>{channel.participantCount} members</span>
                                                    <button 
                                                        className={styles.threeDotsButton} 
                                                        onClick={(e) => {handleChannelOptions(e, showOptions === index ? null : index)}} title="options"
                                                    >
                                                        ⋮
                                                    </button>
                                                    <div className={styles.channelActivity}>
                                                        <span className={styles.activityIndicator}>💚 Active now!</span>
                                                        <span className={styles.activityIndicator} onClick={(e) => handleChannelChatClick(e, channel)}>💚 Chat📃</span>
                                                    </div>
                                            </li>
                                            {showOptions === index && (
                                                <div className={styles.messageOptionsMenu}>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleCopyInviteLink(e, channel._id);setShowOptions(null)}}>
                                                        <CopyLinkIcon/>
                                                        Copy Invite Link
                                                    </button>

                                                    {channel.membership==='member' && <button 
                                                        onClick={(e) => 
                                                        {handleLeaveChannel(e, channel._id);setShowOptions(null)}}>
                                                            <LeaveGroupIcon/>
                                                            Leave Channel
                                                        </button>
                                                    }
                                                    {channel.membership==='left' && <button 
                                                        onClick={() => 
                                                        {handleDeleteChannel(channel._id);setShowOptions(null)}}>
                                                            <DeleteIcon/>
                                                            Delete Channel
                                                        </button>
                                                    }
                                                    <button 
                                                    onClick={(e) => {handleReportChannelPopup(channel._id);setShowOptions(null)}}>
                                                        <ReportIcon/>
                                                        Report Channel
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </ul>
                </div>
            )}

            <div className={`${styles.createChannelSection} ${styles.pnChannel}`}>
                <h3>Create Channel!</h3>
                <p className={styles.sectionSubtext}>Bring Friends together</p>
                {!showChannelCreation && <button onClick={handleShowChannelCreation} className={styles.primaryAction}>
                    Create New Channel
                </button>}
            </div>

            {showChannelCreation && (
                <div className={styles.mainContent}>
                    <div className={styles.leftColumn}>
                        <div className={styles.channelCreationForm}>
                            <h4>🌈 Give Your Channel a Special Name 🌈</h4>
                            <input
                                type="text"
                                value={channelName}
                                onChange={(e) => setChannelName(e.target.value)}
                                placeholder="Set Channel Name"
                                className={styles.channelNameInput}
                            />
                            <button onClick={handleCreateChannel} className={styles.createButton}>
                                🎊 Create Channel! 🎊
                            </button>
                            <button onClick={handleShowChannelCreation} className={styles.closeCreateChannelButton}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div className={styles.rightColumn}>
                        {(projectNetworkList || projectNetworkList.length !== 0) &&  (
                            <div className={`${styles.networksSection} ${styles.pnChannel}`}>
                                <h3>Add Friends</h3>
                                <ul>
                                    {projectNetworkList?.map(network => (
                                        <li key={network._id} className={styles.networkItem} 
                                        onClick={(e) => handleSelectNetwork(e, network._id)}
                                        >
                                            <div className={styles.networkInfo} >
                                                <img title={network.name} src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                                <span className={styles.networkName}>💫 {network.name} 💫</span>
                                                <span className={styles.connectionTime}>{network.skills}</span>
                                                <input type="checkbox" checked={selectedNetworks.includes(network._id)}/>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                {(!projectNetworkList || projectNetworkList.length === 0) && (
                                <div className={styles.emptyState}>
                                    <p>🥺 No connections yet? Let's find some amazing people to connect with! 🥺</p>
                                </div> 
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
            {reportChannelPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popupContent}>
                        <h2>Reporting Channel</h2>
                        <p>Thanks, Reported Channel are reviewed shortly.</p>
                            <textArea
                                type="text"
                                value={reportMessage}
                                onChange={(e) => setReportMessage(e.target.value)}
                                placeholder="Report Message (Optional)"
                                className={styles.reportMessageInput}
                            />
                        <div className={styles.popupActions}>
                            <button onClick={(e)=>handleReportChannel(e, reportChannelId)} className={styles.confirmButton}>Report</button>
                            <button onClick={cancelReportChannel} className={styles.cancelButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}

            {(!newChannels || newChannels.length != 0) && (
                <div className={`${styles.myChannelsSection} ${styles.pnChannel}`}>
                    <h2>👥New Channels👥 ({newChannels.length})</h2>
                    <ul>
                    <div className={styles.channelBox}>
                        <div className={styles.channelContainer}>
                            {newChannels?.map((channel, index) => (
                                <div  className={styles.channelItem}>
                                    <li key={channel._id} onClick={(e) => handleChannelClick(e, channel)}>
                                    <div className={styles.channelContent}>
                                        <img title={channel.name} src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultChannel1}alt="pfp" className={styles.networkProfilePicture} />
                                        <span className={styles.channelName}>🌟 {channel.name} 🌟</span>
                                        <span className={styles.channelMembers}>{channel.participantCount} members</span>
                                            <div className={styles.channelActivity}>
                                            <span className={styles.activityIndicator}>
                                                <button
                                                    className={`${styles.joinButton} ${joined(channel._id) ? styles.joined : ''}`}
                                                    onClick={(e) => handleJoinChannel(e, channel._id)}
                                                    disabled={joined(channel._id)}
                                                >
                                                    {joined(channel._id) ? (
                                                        <>
                                                            <span className={styles.checkIcon}>✓</span>
                                                            Joined
                                                        </>
                                                    ) : (
                                                        '💚 Join Channel'
                                                    )}
                                                </button>
                                                </span>
                                            </div>
                                    </div>
                                    </li>
                                </div>
                            ))}
                        </div>
                    </div>
                    </ul>
                </div>
            )}
            {activeChannelChat && (
                <SocialMessageBox socialType={socialType} social={activeChannelChat} onClose={handleCloseChat} /> 
            )}
        </div>
    );
}
export default Channels;